import styles from './footer.module.css';
import Map from '../map/Map';
import { useContext } from 'react';
import AppContext from '../../contexts/Appcontext';
import { CiMail } from "react-icons/ci";
import { PiWhatsappLogoThin } from "react-icons/pi";
import { PiTelegramLogoThin } from "react-icons/pi";
import { CiInstagram } from "react-icons/ci";


export default function Footer() {

  const { siteInfos:
    { address, email1, email2, fax, instagram, instagram_id, messenger_phone, phone1, phone2, phone3, phone4, telegram, telegram_id, webname, whatsapp }
  } = useContext(AppContext);

  return (
    <footer className={styles.container}>
      <div className={styles.dimmer}>
        <div className={`${styles.footerContent} container-lg`}>

          <address className={styles.address_container}>
            <strong className='d-block h3 fw-bold mb-4'>{webname}</strong>

            <div className='d-flex flex-column gap-3'>
              <div className='d-flex gap-2'>
                <p>تلفن: </p>
                <div className='d-flex flex-column row-gap-2 column-gap-4'>
                  <div className='d-flex flex-wrap row-gap-2 column-gap-4'>
                    <a href={`tel:${phone1}`}>{phone1}</a>
                    <a href={`tel:${phone2}`}>{phone2}</a>
                  </div>
                  <div className='d-flex flex-wrap row-gap-2 column-gap-4'>
                    <a href={`tel:${phone3}`}>{phone3}</a>
                    <a href={`tel:${phone4}`}>{phone4}</a>
                  </div>
                </div>
              </div>
              <div className='d-flex gap-2'>
                <p>فکس: </p>
                <a href={`fax:${fax}`}>{fax}</a>
              </div>
              <div className='d-flex gap-2'>
                <p>واتساپ و تلگرام:</p>
                <a href={`tel:${messenger_phone}`}>{messenger_phone}</a>
              </div>
              <div className='d-flex gap-2'>
                <p>ایمیل: </p>
                <div className='d-flex flex-column row-gap-2 column-gap-4'>
                  <a href={`mailto:${email1}`}>{email1}</a>
                  <a href={`mailto:${email2}`}>{email2}</a>
                </div>
              </div>
              <div className='d-flex gap-2'>
                <p>آدرس: </p>
                <p>{address}</p>
              </div>
            </div>

            <div className='d-flex gap-3 mt-4 justify-content-center justify-content-sm-start'>
              {instagram && <a className={styles.icon_container} href={instagram} rel='noreferrer noopener' target='_blank'><CiInstagram className={styles.icon} /></a>}
              {telegram && <a className={styles.icon_container} href={telegram} rel='noreferrer noopener' target='_blank'><PiTelegramLogoThin className={styles.icon} /></a>}
              {whatsapp && <a className={styles.icon_container} href={whatsapp} rel='noreferrer noopener' target='_blank'><PiWhatsappLogoThin className={styles.icon} /></a>}
              {email1 && <a className={styles.icon_container} href={`mailto:${email1}`} rel='noreferrer noopener' target='_blank'><CiMail className={styles.icon} /></a>}
            </div>
          </address>

          <div className={styles.map_container}>
            <Map className={styles.map} />
          </div>

        </div>

        <strong className='text-center mb-3'>
          <a href='https://www.metavia.ir/' rel='noreferrer noopener' target='_blank'>طراحی و توسعه: Metavia</a>
        </strong>

      </div>
    </footer >
  )
}
